export default "__VITE_ASSET__SWM2WrJ1__"